import { SET_PAYMENTS, GET_PAYMENTS } from './actionTypes'

export function setPayments(data) {
  return {
    type: SET_PAYMENTS,
    data,
  }
}

export function getPaymentsSaga(data) {
  return {
    type: GET_PAYMENTS,
    data,
  }
}
